/**
 * Finish the pitch session and always leave the room UI.
 *
 * The engine may have completed the session already (the agent ended the call),
 * so `finish` is best-effort: whatever it returns, the founder must not stay on
 * a dead room with a still-valid LiveKit token.
 */
export async function finishAndLeave(
  finish: () => Promise<unknown>,
  onSessionEnd?: () => void
): Promise<void> {
  try {
    await finish()
  } catch (error) {
    console.error('Failed to finish pitch session', error)
  } finally {
    onSessionEnd?.()
  }
}
